import './guastavinos/style';
import FormStructure from './guastavinos/form_structure';

export default FormStructure;